import {
  Component,
  HostBinding,
  Input,
  OnChanges,
  SimpleChange,
  SimpleChanges
} from '@angular/core';
import { IStep } from './models/step.interface';
import { ClaimEditComponent } from '../../../pages/claims/components/edit/claim-edit.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'upsc-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  providers: [DatePipe]
})
export class StepperComponent implements OnChanges {
  @HostBinding('class') public hostClass = 'stepper';

  @Input() public steps: IStep[];
  @Input() public currentStep: number;

  public progress: number;

  constructor(private claimComp: ClaimEditComponent) {
  }

 

  public ngOnChanges(changes: SimpleChanges) {
    this.onCurrentStepChanged(changes['currentStep']);
  }

  

  private onCurrentStepChanged(change: SimpleChange) {
    if (!change || !change.currentValue) {
      return;
    }

    this.setProgress();
  }


  public setCurrentStepManual(order: number){
    this.claimComp.setCurrentStepManually(order);
  }

  private setProgress() {
    if (!this.steps || !this.steps.length) {
      this.progress = 0;
      return;
    }

    this.steps.forEach(
      (step) => {
        step.isActive = step.order === this.currentStep;
      },
    );

    this.progress = (this.currentStep - 1) * 100 / (this.steps.length - 1);
  }
}
